<template>
  <div class="tab-tags">
    <div class="more-clue"></div>
    <swiper :options="swiperOption" ref="mySwiper">

      <comp-tag-tab-item
        v-for="tag in tagList"
        :key="tag.jobCode"
        :tag="tag.jobName"
        @clickTagItem="clickTagList(tag)"
      ></comp-tag-tab-item>

    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper } from 'vue-awesome-swiper';
import CompTagTabItem from './CompTagTabItem';

export default {
  name: 'carrousel',
  components: {
    swiper,
    CompTagTabItem,
  },
  props: {
    tagList: Array,
  },
  data() {
    return {
      swiperOption: {
        autoHeight: true,
        freeMode: true,
        slidesOffsetBefore: 5,
        slidesOffsetAfter: 50,
        slidesPerView: 'auto',
        spaceBetween: 5,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  methods: {
    clickTagList(tag) {
      this.$emit('clickTagList', tag);
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-tag-tab.scss">

</style>



// WEBPACK FOOTER //
// src/components/CompTagTabList.vue